import { Component } from '@angular/core';
import { NavController, AlertController,NavParams} from 'ionic-angular';
import { AppState } from '../../../app/app.global';
@Component({
  selector: 'receipt-page',
  templateUrl: 'receipt.html'
})
export  class ReceiptPage{
  remarks:string = "";
  constructor(public navCtrl: NavController,private alertCtrl: AlertController,public navParm :NavParams,public global: AppState ) {

  }
  confirmReceipt(status:string,statusName:string){
  	let alert = this.alertCtrl.create({
	    message: '确定发送'+statusName+'会议的回执吗?',
	    buttons: [
	      {
	        text: '取消',
	        role: 'cancel',
	      },
	      {
	        text: '确认',
	        handler: () => {
	        	// let params = {"msgId":this.navParm.data.msgId,"userId":this.navParm.data.userId,"remarks":this.remarks,"receiptStauts":status};
	          //this.webService.post(RECEIPT,params,提交回执).then(anyObj =>this.handleReceiptData(anyObj));
	         // this.handleReceiptData({'msg':'提交回执成功','code':'200'});
	        }
	      }
	    ]
	  });
	  alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/message/receipt/receipt.ts